import 'global.css'
import App from 'app'

export const wrapPageElement = ({ element, props }) => {
  return (
    <App {...props} >
      {element}
    </App>
  );
}

export const onInitialClientRender = () => {
  // When a text input element (input or textarea) has focus and the window resizes
  // (typically due to a virtual keyboard appearing on mobile devices), recenter the focused input.
  window.addEventListener('resize', () =>
    document.activeElement &&
    document.activeElement.selectionStart !== undefined &&
    document.activeElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
  );
}

export const onServiceWorkerUpdateReady = () => {
  console.log(new Date().toISOString() + ": app update available.")
}

export const shouldUpdateScroll = ({ routerProps }) => {
  const { disableScrollUpdate } = routerProps.location.state || {};
  // If disableScrollUpdate is true, return false to stop Gatsby from moving the scrollbar
  return !disableScrollUpdate;
};
